import React from "react";

// styles
import { AssetHeroColGridItem } from "./styles";

export const HeroAsset = ({ children }) => {
    return (
        <AssetHeroColGridItem item sm={12} md={8} lg={8}>
            {children}
        </AssetHeroColGridItem>
    );
};
